import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M3.75 12H11.75M3.75 12V6M3.75 12L3.75 18M11.75 12V6M11.75 12V18" strokeLinecap="square" />
		<Path d="M20 18.75V14.5M20 10.75V14.5M16.25 8.74999V9L15 14.5L20 14.5" />
	</SVG>
);
